module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAD1BMVEUAAACbm5ucnJyZmZmZmZkQff1FAAAABHRSTlMAZjGjdksk6AAAADJJREFUGNNjAAMlBjhgclGAsxldBKjKZhIUFBR2MQSSCgwqLjDghMxGVkNtN2D6EeF3AOhoDWvpDmzbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/handelAdd.png
// module id = s3pA
// module chunks = 104